// src/components/HeroSection.jsx

import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

import { sectionVariants, itemVariants, AnimatedText } from '../animations'; 

const HeroSection = () => {
    const { scrollYProgress } = useScroll();
    const scale = useTransform(scrollYProgress, [0, 1], [1, 0.8]);
    const y = useTransform(scrollYProgress, [0, 1], [0, 100]);
    
    

    return (
        <section id="home" className="h-screen w-full relative flex items-center justify-center text-center overflow-hidden">
            
            <div className="absolute inset-0 z-0 overflow-hidden">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="w-full h-full object-cover"
                >
                    <source src="/hero-video.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <div className="absolute inset-0 bg-black/80 z-10"></div>
                </div>

                <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/50 z-20"></div>

                {/* FOREGROUND TEXT CONTENT (No changes here) */}
            <motion.div 
                className="relative z-30 px-4"
                style={{ scale, y }}
                variants={sectionVariants}
                initial="hidden"
                animate="visible"
            >
                <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl lg:text-8xl font-extrabold text-white leading-tight tracking-tighter mb-6">
                    Engineering <br />
                    <span className="text-cyan-400 dark:text-red-500">Digital</span>
                    <span className="text-red-500 dark:text-cyan-400"> Reality.</span>
                </motion.h1>
                <AnimatedText
                    text="We architect brilliant solutions for the digital age. Based in Sri Lanka, serving the world."
                    className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto"
                    variants={sectionVariants}
                />
            </motion.div>
        </section>
    );
};

export default HeroSection;